import { z } from 'zod';
import { AuditEvent } from './audit.js';
import { Role } from './auth.js';
/** CER user administration (docs/user-admin.md): every account, searched and inspected by a CER administrator (`users:admin`). */
export const UserStatus = z.enum(['active', 'deactivated']);
export const UserQuery = z.object({
    /** Username, display name, email or organisation name (partial, any case). */
    q: z.string().trim().min(1).max(100).optional(),
    role: Role.optional(),
    status: UserStatus.optional(),
    /** The previous page's `nextAfter`: users whose username sorts after it. */
    after: z.string().min(1).max(200).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const UserSummary = z.object({
    id: z.string(),
    username: z.string(),
    displayName: z.string(),
    roles: z.array(Role),
    participantId: z.string().nullable(),
    participantName: z.string().nullable(),
    provider: z.enum(['local', 'entra']),
    email: z.string().nullable(),
    emailVerified: z.boolean(),
    isTester: z.boolean(),
    status: UserStatus,
    createdAt: z.string(),
});
export const UserList = z.object({
    items: z.array(UserSummary),
    /** Pass as `after` for the next page; null when this is the last. */
    nextAfter: z.string().nullable(),
});
export const UserDetail = UserSummary.extend({
    deactivatedAt: z.string().nullable(),
    passwordChangedAt: z.string().nullable(),
    /** Set on accounts the Testing portal created or imported. */
    testingOnboardedAt: z.string().nullable(),
    /** The latest successful `auth.login`; null if none. Only password sign-ins write `auth.login`, so an Entra account is always null. */
    lastSignInAt: z.string().nullable(),
    updatedAt: z.string(),
});
export const UserEventQuery = z.object({
    /** Events with an id below this (the previous page's `nextBefore`). */
    before: z.coerce.number().int().positive().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(100),
});
/** `actor`: the user did it. `subject`: it was done to the account. `both`: the user did it to their own account (e.g. a password change). */
export const UserEventRelation = z.enum(['actor', 'subject', 'both']);
export const UserAuditEvent = AuditEvent.extend({ relation: UserEventRelation });
export const UserEventList = z.object({
    items: z.array(UserAuditEvent),
    nextBefore: z.number().int().nullable(),
});
//# sourceMappingURL=user-admin.js.map